import { gql } from '@apollo/client';
import { articleCommonData } from './articleCommonData';

export const getSortedArticlesForUnauthenticatedUser = gql`
  query getSortedArticles($where: ArticleWhereInput, $sortBy: ArticlesOrder, $skip: Int!, $take: Int!) {
    getSortedArticles(where: $where, sortBy: $sortBy, skip: $skip, take: $take) {
      articles {
        ${articleCommonData}
      }
      articlesCount
    }
  }
`;
